export function objectToOptions(array) {
  const options = [];
  if (array) {
    array.map((object) => {
      options.push(object.regionName);
    });
  }

  return options;
}

export function arrayToOptions(array) {
  const options = [];
  if (array) {
    array.map((object) => {
      options.push(object.name);
    });
  } else {
    return false;
  }

  return options;
}

export function hasShallowChanges(obj1, obj2) {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys2.length === 0) {
    return false;
  }

  if (keys1.length !== keys2.length) {
    return true;
  }

  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return true;
    }
  }

  return false;
}

export function formatTinNo(inputtedValue) {
  let value = inputtedValue.replace(/\D/g, "").substring(0, 14);

  if (value.length === 0) return "";

  let result = value;

  if (value.length > 3 && value.length <= 6) {
    result = `${value.slice(0, 3)}-${value.slice(3)}`;
  } else if (value.length > 6 && value.length <= 9) {
    result = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
  } else if (value.length > 9) {
    result = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(
      6,
      9
    )}-${value.slice(9)}`;
  }
  return result;
}
